<template>
<el-dialog
  @close="close"
  append-to-body
  close-on-click-modal
  :title="title"
  :visible.sync="dialogVisible"
  width="900px">
  <span v-if="urlType == '-1'">错误的url类型</span>
  <img v-else-if="urlType == 'image'" style="width: 500px;margin:0 auto;display: block;"  :src="url" alt=""/>
  <video v-else-if="urlType == 'video'" style="width: 500px" controls :src="url"></video>
  <!-- <iframe v-else :src='`https://docs.xinanyun.cn/op/embed.aspx?src=${url}&wdStartOn=1`' width='850px' height='600px' frameborder='0'>这是嵌入 <a target='_blank' href='http://office.com'>Microsoft Office</a> 文档，由 <a target='_blank' href='http://office.com/webapps'>Office Online</a> 支持。</iframe> -->
  <iframe v-else :src='`${ platformUrl }/apps/res/onlinePreview?url=${url}`' width='100%' height='600px' frameborder='0'>这是嵌入 <a target='_blank' href='http://office.com'>Microsoft Office</a> 文档，由 <a target='_blank' href='http://office.com/webapps'>Office Online</a> 支持。</iframe>
  <span slot="footer" class="dialog-footer">
    <el-button size="mini" @click="dialogVisible = false">关 闭</el-button>
    <el-button size="mini" type="primary" @click="downloadFile">批量下载</el-button>
  </span>
</el-dialog>
</template>

<script>
import * as types from '@/vuex/types'
import store from '@/vuex/store'
import {api} from '@/api/api'
export default {
  components: {
  },
  data () {
    return {
      title: '',
      dialogVisible: true,
      url: '',
      title: '预览'
    }
  },
  computed: {
    platformUrl () {
      return store.getters.sysUrl.ADMIN_PLATFORM_URL
    },
    urlType () {
      // 后缀获取
      var suffix = ''
      // 获取类型结果
      var result = ''
      try {
        var flieArr = this.url.split('.')
        suffix = flieArr[flieArr.length - 1]
      } catch (err) {
        suffix = ''
      }
      // fileName无后缀返回 false
      if (!suffix) {
        return '-1'
      }
      // 图片格式
      var imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif']
      // 进行图片匹配
      result = imglist.some(function (item) {
        return item == suffix
      })
      if (result) {
        result = 'image'
        return result
      }
      var videolist = ['mp4', 'm2v', 'mkv']
      result = videolist.some(function (item) {
        return item == suffix
      })
      if (result) {
        result = 'video'
        return result
      }
    }
  },
  mounted () {
  },
  methods: {
    downloadFile(){
      window.open(this.url)
    },
    close() {
      this.$el.parentNode.removeChild(this.$el);
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/showFile/showFile.vue